// base
import { createSlice } from '@reduxjs/toolkit';
import { AUTH_SLICE_NAME } from '../actions/auth.action';

// thunks
import {
  userLogin,
  userLogout,
  userSignUp,
  getAuthList,
  getSms,
  getSmsVerify,
  postApproval,
  postReject,
  getSmsVerifyForgot
} from '../thunks/auth.thunk';
import { userLoginV2 } from '../thunks/auth.thunkV2';

// constants
import { newNationOptions, PROJECT_NAME } from 'constants';

// initialState
const initialState = {
  userInfo: undefined,
  approvalInfo: undefined,
  isLogin: false,
  verifyResult: undefined,
  auth: [],
  totalMap: undefined,
  temporaryPasswdStatus: false,
  userId: undefined,
  signUpForm: {
    projectName: PROJECT_NAME,
    nationId: newNationOptions[0].value,
    code: '',
    mobile: null,
    name: {
      firstName: '',
      lastName: ''
    },
    password: '',
    passwordConfirm: '',
    terms: false,
    company: null
  }
};

// createSlice
const authSlice = createSlice({
  name: AUTH_SLICE_NAME,
  initialState,
  reducers: {
    setSignUpForm: (state, action) => {
      state.signUpForm = action.payload;
    },
    setLogout: () => initialState,
    setTemporaryPasswdStatus: (state, action) => {
      state.temporaryPasswdStatus = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSms.fulfilled, (state, action) => {
        const { userInfo } = action.payload;
        state.userInfo = { userInfo };
      })
      .addCase(getSmsVerify.fulfilled, (state, action) => {
        const res = action.payload;
        state.verifyResult = res.resultObject;
      })
      .addCase(getSmsVerifyForgot.fulfilled, (state, action) => {
        const res = action.payload;
        state.verifyResult = res.resultObject;
      })
      .addCase(userLogin.fulfilled, (state, action) => {
        const { isLogin, userInfo, temporaryPasswdStatus, userId } = action.payload;

        state.isLogin = isLogin;
        state.userInfo = userInfo;
        state.temporaryPasswdStatus = temporaryPasswdStatus;
        state.userId = userId;
      })
      .addCase(userLogin.rejected, (state) => {
        state.isLogin = false;
        state.userInfo = undefined;
        state.temporaryPasswdStatus = false;
      })
      .addCase(userLogout.fulfilled, (state, action) => {
        const { userInfo } = action.payload;

        state.userInfo = userInfo;
      })
      .addCase(userSignUp.fulfilled, (state, action) => {
        const res = action.payload;

        state.userInfo = res;
      })
      .addCase(getAuthList.fulfilled, (state, action) => {
        const res = action.payload;

        state.auth = res.resultList || [];
        state.totalMap = res.totalMap;
      })
      .addCase(postApproval.fulfilled, (state, action) => {
        const res = action.payload;

        state.approvalInfo = res;
      })
      .addCase(postReject.fulfilled, (state, action) => {
        const res = action.payload;

        state.approvalInfo = res;
      })

      /**
       * ==============================================================================================
       * 2024.10.25 - KDONG
       * ==============================================================================================
       */
      .addCase(userLoginV2.fulfilled, (state, action) => {
        const { isLogin, userInfo, temporaryPasswdStatus, userId } = action.payload;

        state.isLogin = isLogin;
        state.userInfo = userInfo || undefined;
        state.temporaryPasswdStatus = temporaryPasswdStatus;
        state.userId = userId;
      });
  }
});

export const auth = authSlice.name;
export const authReducer = authSlice.reducer;
export const authActions = authSlice.actions;
export default authSlice.reducer;
